/**
 * Creates a block checker function that validates if any of the provided checker functions
 * detect changes between current and initial blocks.
 *
 * @param {...Function} checkers - Variable number of checker functions that each take
 *                                 (current, initial) parameters and return boolean
 * @returns {Function} A function that takes (current, initial) parameters and returns
 *                     true if any checker detects changes, false otherwise
 *
 * @example
 * // Create a checker with multiple validation functions
 * const hasBlockChanged = createBlockChecker(
 *   areFieldsChanged,
 *   isDelayChanged,
 *   isExecPolicyChanged
 * );
 *
 * // Use the checker
 * if (hasBlockChanged(currentBlock, initialBlock)) {
 *   console.log('Block has changes');
 * }
 *
 * @example
 * // Create a custom checker for specific validations
 * const hasConfigChanged = createBlockChecker(
 *   (current, initial) => current.timeout !== initial.timeout,
 *   (current, initial) => current.retries !== initial.retries
 * );
 */
export const createBlockChecker =
    (...checkers) =>
    (current, initial) =>
        checkers.some((checker) => checker(current, initial));
